import { useState, useEffect } from "react";

import expedientesService from "../../../services/expedientesService";
import { colorIdentifier, resumeJurisdiction } from "../../../services/common";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "layouts/DashboardLayout";
import SearchBar from "./components/SearchBar";
import { FileList } from "./components/FileList";
import { useNotification } from "../../../context/NotificationContext";
import DataTableFile from "./components/DataTableFile";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import { FormatListBulletedOutlined, TableChartOutlined} from "@mui/icons-material";
import { IconButton, Link, Skeleton } from "@mui/material";
import DashboardNavbar from "navbars/DashboardNavbar";

const Files = () => {
  const [expedientes, setExpedientes] = useState([]);
  const [searchTerm, setSearchTerm] = useState({ description: "", state: "" });
  const [loading, setLoading] = useState(true);
  const { showNotification } = useNotification();
  const [viewTable, setViewTable] = useState(true);

  const columns = [
    {
      Header: "Estado",
      accessor: "estado",
      sortType: (rowA, rowB, columnId) => {
        const a = rowA.values[columnId] || "";
        const b = rowB.values[columnId] || "";
        return String(a).localeCompare(String(b));
      },
    },
    { Header: "Carátula", accessor: "caratula" },
  ];
  const [rows, setRows] = useState([]);

  useEffect(() => {
    async function fetchExpedientesFiltered() {
      setLoading(true);
      const data = await expedientesService.getAllExpedientesFiltered(searchTerm);
      if (data.error) {
        showNotification(data.message, "error");
      } else {
        if (data) {
          const data2 = data.map((cell) => {
            const file = {
              id: cell.id,
              numero: cell.numero,
              anio: cell.anio,
              caratula: cell.caratula,
              jurisdiccion: resumeJurisdiction(cell.jurisdiccion),
              estado: cell.estado,
            };
            return file;
          });
          setExpedientes(data2);

          const dataToTable = data.map((cell) => {
            const rw = {
              caratula: (
                <Link href={`/file/detail/${cell.id}`} color="inherit" underline="none">
                  <MDBox display="flex" alignItems="center">
                    <MDBox>
                      <MDTypography display="block" variant="button" fontWeight="medium">
                        {resumeJurisdiction(cell.jurisdiccion)} {cell.numero}/{cell.anio}
                      </MDTypography>
                      <MDTypography
                        display="block"
                        variant="caption"
                        color="text"
                        fontWeight="medium"
                      >
                        {cell.caratula}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </Link>
              ),
              // estado: cell.estado,
              estado: (
                <MDBadge
                  badgeContent={cell.estado}
                  color={colorIdentifier(cell.estado)}
                  container
                ></MDBadge>
              ),
            };
            return rw;
          });
          setRows(dataToTable);
        }
      }
      setLoading(false);
    }
    fetchExpedientesFiltered();
  }, [searchTerm]);

  function handleEnableTableView(value) {
    setViewTable(value);
  }

  return (
    <DashboardLayout>
      <DashboardNavbar title="Listado de expedientes" />
      <MDBox position="relative">
        <MDBox position="relative" mb={2}>
          <SearchBar onSearchChange={setSearchTerm}></SearchBar>
        </MDBox>
        {loading ? (
          <>
            <Skeleton variant="text" width={180} height={32} sx={{ mb: 2 }} />
            {viewTable ? (
              <>
                <Skeleton variant="rectangular" height={48} sx={{ borderRadius: 1, mb: 1 }} />
                {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                  <Skeleton key={i} variant="rectangular" height={44} sx={{ borderRadius: 1, mb: 0.5 }} />
                ))}
              </>
            ) : (
              [1, 2, 3, 4, 5].map((i) => (
                <Skeleton key={i} variant="rectangular" height={72} sx={{ borderRadius: 2, mb: 2 }} />
              ))
            )}
          </>
        ) : viewTable ? (
          <>
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <MDBox>
                <MDTypography variant="h5" fontWeight="medium">
                  Total de registros: {expedientes.length}
                </MDTypography>
              </MDBox>
              <IconButton
                onClick={() => handleEnableTableView(false)}
                color="info"
                sx={{
                  transition: "0.3s",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                  },
                }}
              >
                <FormatListBulletedOutlined />
              </IconButton>
            </MDBox>
            <DataTableFile table={{ columns, rows }}></DataTableFile>
          </>
        ) : (
          <>
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <MDBox>
                <MDTypography variant="h5" fontWeight="medium">
                  Total de registros: {expedientes.length}
                </MDTypography>
              </MDBox>
              <IconButton
                onClick={() => handleEnableTableView(true)}
                color="info"
                sx={{
                  transition: "0.3s",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                  },
                }}
              >
                <TableChartOutlined />
              </IconButton>
            </MDBox>
            <FileList files={expedientes}></FileList>
          </>
        )}
      </MDBox>
    </DashboardLayout>
  );
};

export default Files;
